import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { BaseDirective } from '../../base.directive';
import { EuiListService } from './services/eui-list.service';

@Component({
    templateUrl: './eui-list.component.html',
    selector: '[euiList], eui-list',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiListComponent extends BaseDirective implements OnInit {

    @Input()
    get isCollapsible() { return this._isCollapsible; }
    set isCollapsible(value) { this._isCollapsible = coerceBooleanProperty(value); }
    _isCollapsible = false;

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-list'),
        ].join(' ').trim();
    }

    @HostBinding('attr.role') role = 'list';

    constructor(private euiListService: EuiListService) {
        super();
    }

    ngOnInit() {
        if (this.isCollapsible) {
            this.euiListService.isCollapsible = this.isCollapsible;
        }
    }
}
